module.exports = __webpack_public_path__ + "img/restaurant.bf778351.png";